import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import LloydMatChooser from "../ItemChooser/LloydMatChooser";
import LloydFormBottom from "../FormBottom/LloydFormBottom";
import LloydOptionsSection from "../OptionBuilder/LloydOptionsSection";
import LloydCatalogue from "../models/LloydCatalogue";
import LocalUrlMaker from "../../../lib/LocalUrlMaker";
import CatchErrors from "../../../Utility/CatchErrors";
import clsx from "clsx";

// For debugging - a fixed position yellow overlay that shows cart
// import CartDebug from "../FormBottom/CartDebug";
//
// let isDev = (process.env.NODE_ENV == 'development') || true; //FIXME

/**
 * Internals of a LloydContainer.
 */
export default function LloydUI({lloydCart, callbacks, lloyd, submitting=false}) {
  // Show items only if every item has its product_unique selected.
  // let showOptions = (!cart.isEmpty()) &&
  //   _.every(cart.itemValuesForOption('product_unique'));


  let cartErrors = lloydCart.validate({lloyd: lloyd}); //FIXME
  let url = new LocalUrlMaker().prefixedPath('/cart_items');

  let classes = getClasses({lloyd, lloydCart});

  return (
    <div id="lloyd-products" className={clsx(classes)}>
      <form method="post" id="lloyd-cart-form" action={url}>

        <CatchErrors><LloydMatChooser
          lloydCart={lloydCart}
          lloyd={lloyd}
          callbacks={callbacks}
        /></CatchErrors>

        <CatchErrors>
          <LloydOptionsSection
            cart={lloydCart}
            lloyd={lloyd}
            callbacks={callbacks}
          />
        </CatchErrors>


        <CatchErrors>
          <LloydFormBottom
            cart={lloydCart}
            callbacks={callbacks}
            cartErrors={cartErrors}
            submitting={submitting}/>
        </CatchErrors>
      </form>
    </div>
  );

  // for debug add this somewhere:
  // {isDev && <CartDebug cart={cart} lloyd={lloyd}/>}
}

function getClasses({lloydCart, lloyd}) {

  let cartCount = lloydCart.items.count();
  let cartErrors = lloydCart.validate({lloyd: lloyd});

  let submitEnabled = (cartCount > 0) && _.isEmpty(cartErrors);

  return clsx(
    ((cartCount > 0) ? "items-in-cart" : "no-items-in-cart"),
    (submitEnabled ? "submit-enabled" : "submit-disabled")
  );
}

LloydUI.propTypes = {
  callbacks: PropTypes.object.isRequired,
  customerVehicle: PropTypes.object,
  // vehicleChoices // dont care?
  // itemsUrl // dont care
  // itemApplications, dispatch // dont care
  cart: PropTypes.object.isRequired,
  lloyd: PropTypes.instanceOf(LloydCatalogue).isRequired,
  // products: PropTypes.object.isRequired,  // keyed by product id
  // lloydProducts: PropTypes.object.isRequired,
  submitting: PropTypes.bool
}

